import DashboardCard from "../common/DashboardCard";

const gradientMap = {
  purple: "from-purple-500 to-indigo-600",
  blue: "from-sky-500 to-blue-600",
  green: "from-green-500 to-emerald-600",
  orange: "from-orange-500 to-amber-600",
};

const OrgStats = ({ stats }) => {
  return (
    <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((item, i) => (
        <DashboardCard
          title={item.title}
          value={item.value}
          icon={item.icon}
          color={item.color}
        />
      ))}
    </div>
  );
};

export default OrgStats;
